import { DATE_FORMAT, JP_DATE_FORMAT, localeMap } from 'app/modules/Constants';
import { format } from "date-fns";

export function formattedDateString({ date, lng }: { date: Date; lng: string }) {
	const dateDisplayFormat = lng === 'jp' ? JP_DATE_FORMAT : DATE_FORMAT;
	const isSwedish = lng === 'sv';
	const formattedDate = format(date, dateDisplayFormat, { locale: localeMap[lng] });

	let renderText: string | React.ReactNode = (
		<span style={{ textTransform: 'capitalize' }}>{formattedDate}</span>
	);

	if (isSwedish) {
		// Capitalize day, lowercase month
		renderText = formattedDate.replace(
			/(\D+),\s(\D+)/,
			(_, day, month) => `${day.charAt(0).toUpperCase() + day.slice(1)}, ${month.toLowerCase()}`
		);
	}

	return { ariaLabelString: formattedDate, renderText };
}
